import './about.scss';

import { size } from 'lodash';

import type { NavigateTo } from '@core/app/scripts/services/navigate-to';
import { About } from '@shared/app/scripts/services/about';
import { Barcodes } from '@pos/app/scripts/services/barcodes';
import { CurrentSession } from '@shared/app/scripts/services/current-session';
import { Event } from '@shared/app/scripts/services/event';
import { LocationManager } from '@shared/app/scripts/services/location-manager';
import { SalesManager } from '@shared/app/scripts/services/sales-manager';
import { SettingsManager } from '@shared/app/scripts/services/settings-manager';
import { Version } from '@shared/app/scripts/services/version';

/*
 * Component responsible for /about route.
 */
angular
  .module('posApp')
  .directive(
    'about',
    (
      about: About,
      barcodes: Barcodes,
      currentSession: CurrentSession,
      event: Event,
      locationManager: LocationManager,
      navigateTo: NavigateTo,
      pos,
      posInstance,
      salesManager: SalesManager,
      settingsManager: SettingsManager,
      version: Version,
    ) => ({
      restrict: 'E',

      scope: true,

      template: require('./about.html').default,

      link: function ($scope, element, attrs) {
        $scope.locationManager = locationManager;
        $scope.navigateTo = navigateTo;
        $scope.pos = pos;
        $scope.posInstance = posInstance;
        $scope.salesManager = salesManager;

        $scope.currentSession = currentSession;
        $scope.settings = settingsManager.settings;

        $scope.version = version;

        // TODO POS-2288 cover with unit test
        $scope.barcodesCount = size(barcodes.db);

        $scope.printQId = settingsManager.settings.printerId;
        $scope.printer = settingsManager.settings.printer;
        $scope.pinProvider = settingsManager.settings.pinProvider;
        $scope.pinId = settingsManager.settings.pinId;
        $scope.secondScreenId =
          settingsManager.settings.secondScreen.secondScreenId;

        about.versions().then((response) => {
          $scope.spynlVersion = response.spynl_app.version;
        });

        event
          .count({
            confirmed: false,
            'created.user._id': currentSession.userId,
          })
          .then((count) => {
            $scope.eventCount = count;
          });
      },
    }),
  );
